import React from 'react';
export function Footer() {
  return <footer className="bg-[#061539] text-white/60 py-12 px-5 text-center text-[13px]" data-id="element-89">
      <div className="max-w-xl mx-auto" data-id="element-90">
        <div className="text-white font-bold text-lg mb-4 flex items-center justify-center gap-2" data-id="element-91">
          <span data-id="element-92">🤝</span> Sistema LSA Fácil™ para Profesores
        </div>

        <p className="mb-8 leading-relaxed max-w-sm mx-auto" data-id="element-93">
          El sistema N°1 para profesores de Lengua de Señas Argentina. Material
          didáctico completo, progresivo y listo para usar en cada clase.
        </p>

        <div className="flex flex-col gap-2 mb-8" data-id="element-94">
          <a href="mailto:soportetusbeneficios@gmail.com" className="hover:text-white transition-colors" data-id="element-95">
            📧 soportetusbeneficios@gmail.com
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-96">
            📱 @centralpack.ar
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-97">
            🌐 centralpack.shop
          </a>
        </div>

        <div className="border-t border-white/10 pt-8 mb-8" data-id="element-98">
          © Sistema LSA Fácil™ 2026 — Todos los derechos reservados.
        </div>

        <p className="italic text-white/40 font-medium" data-id="element-99">
          🤟 "Mejores profesores. Mejores señantes. Mejor Argentina."
        </p>
      </div>
    </footer>;
}